<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	// Stores
	import SportStore from '@/Stores/Sport/SportStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	// Services
	import { getUrlParameter, removeUrlParameter, setUrlParameter } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Partials
	import GroupsList from '@/Partials/Sport/Markets/Groups/_List.svelte';
	import GroupSetsList from '@/Partials/Sport/Markets/GroupSets/_List.svelte';
	import ManageTiers from '@/Partials/Sport/Markets/Tiers/_ManageTiers.svelte';
	import ManageCompetitions from '@/Partials/Sport/Markets/Competitions/_ManageCompetitions.svelte';

	export let action;

	const actionMap = {
		groups: {
			title: 'Market Groups',
			component: GroupsList,
			create_permission: 'market_groups.create',
			read_permission: 'market_groups.read',
			slug: 'groups',
			new: 'New Market Group'
		},
		'group-sets': {
			title: 'Market Group Sets',
			component: GroupSetsList,
			create_permission: 'market_group_sets.create',
			read_permission: 'market_group_sets.read',
			slug: 'group-sets',
			new: 'New Market Group Set'
		},
		tiers: {
			title: 'Tier Markets',
			component: ManageTiers,
			read_permission: 'market_groups.update',
			slug: 'competitions'
		},
		competitions: {
			title: 'Competition Markets',
			component: ManageCompetitions,
			read_permission: 'market_groups.update',
			slug: 'competitions'
		}
	};
	$: sportId = (location.search && parseInt(getUrlParameter('sport'))) || false;

	let loading = SportStore.getSports();

	function changeSport(sport_id) {
		if (typeof parseInt(sport_id) !== 'undefined' && sport_id !== false) {
			setUrlParameter('sport', parseInt(sport_id));
			sportId = parseInt(sport_id);
		} else {
			removeUrlParameter('sport');
			sportId = false;
		}
	}
</script>

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center justify-between w-full">
					<h1 class="text-xl font-bold">{actionMap[action].title} List</h1>
					<div class="flex-1 text-center">
						<div class="btn-group">
							{#each Object.keys(actionMap) as item}
								{#if $ACLStore && ACLStore.granted(actionMap[item].read_permission)}
									<Link
										href={sportId
											? `/sport/markets/${actionMap[item].slug}?sport=${sportId}`
											: `/sport/markets/${actionMap[item].slug}`}
										class="btn {item === action ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										{actionMap[item].title}
									</Link>
								{/if}
							{/each}
						</div>
					</div>
				</div>
			</div>
			<!-- /Page Header -->
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<div class="flex items-center justify-between">
					<SelectInput
						className="py-1 w-1/3"
						name="sport"
						required={true}
						bind:value={sportId}
						on:change={(event) => changeSport(event.target.value)}
					>
						<option value={false}>Select Sport...</option>
						{#each $SportStore.sortBy('name').all() as sport (sport.id)}
							{#if parseInt(sport.id) == parseInt(sportId)}
								<option value={parseInt(sport.id)} selected>{sport.name}</option>
							{:else}
								<option value={parseInt(sport.id)}>{sport.name}</option>
							{/if}
						{/each}
					</SelectInput>
					{#if actionMap[action].new && $ACLStore && ACLStore.granted(actionMap[action].create_permission)}
						<Link
							class="btn btn-primary"
							href={sportId
								? `/sport/markets/${actionMap[action].slug}/create?sport=${sportId}`
								: `/sport/markets/${actionMap[action].slug}/create`}
						>
							{actionMap[action].new}
						</Link>
					{/if}
				</div>
				<!-- ACTION COMPONENT -->
				<svelte:component this={actionMap[action].component} {sportId} />
			</div>
		</div>
	{/await}
</div>
